import { GlobalOutlined } from '@ant-design/icons';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { getAsyncSelectOutputReferences } from '../async-select/getAsyncSelectOutputReferences';
import { hydrateAsyncWidget } from '../async-select/utils/hydrateAsyncWidget';
import {
  AsyncValueConfigComponent,
  AsyncValueConfigSchema,
} from './AsyncValueConfigComponent';
import { AsyncValueWidgetComponent } from './AsyncValueWidgetComponent';
import { AsyncValueWidgetPreview } from './AsyncValueWidgetPreview';
import { IAsyncValueWidget } from './IAsyncValueWidget';
import { createAsyncValueFormSchema } from './createAsyncValueFormSchema';
import { getAsyncValueWidgetReference } from './getAsycValueWidgetReference';

export const asyncValueWidgetObjectName = (code: string) => `${code}@object`;

export const AsyncValueWidgetType: IWidgetType<IAsyncValueWidget> = {
  type: WidgetType.AsyncValue,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Campo valore da servizio',
  icon: <GlobalOutlined />,
  getReference: getAsyncValueWidgetReference,
  getSiblingReferences: getAsyncSelectOutputReferences,
  hasValue: true,
  formComponent: AsyncValueWidgetComponent,
  createFormSchema: createAsyncValueFormSchema,
  previewComponent: AsyncValueWidgetPreview,
  configValidator: AsyncValueConfigSchema,
  configComponent: AsyncValueConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [RequiredRule, CustomWarningsRule],
  /**
   * Per i widget asyncValue nell'hydrate ritorno, come valore
   * non il value del widget, ma la label mostrata all'utente,
   * così da poter valorizzare correttamente il pdf.
   */
  hydrate: hydrateAsyncWidget,
};
